import Vuex from 'vuex';
import { shallowMount, createLocalVue } from '@vue/test-utils';
import QtyButtonBase from './QtyButtonBase';

const localVue = createLocalVue();
localVue.use(Vuex);

let notifyWarnMock = jest.fn();

const store = new Vuex.Store({
  actions: {
    notifyWarn: notifyWarnMock
  }
});

const factory = (propsData) => {
  return shallowMount(QtyButtonBase, {
    localVue,
    store,
    propsData: {
      ...propsData
    }
  });
};

describe('QtyButtonBase', () => {

  describe('computed', () => {
    describe('minQtyReached', () => {
      test('set to true when qty == minQty', () => {
        const localThis = { localQty: 1, minQty: 1 };
        expect(QtyButtonBase.computed.minQtyReached.call(localThis)).toBe(true);
      });

      test('set to false when qty < minQty', () => {
        const localThis = { localQty: 1, minQty: 2 };
        expect(QtyButtonBase.computed.minQtyReached.call(localThis)).toBe(false);
      });
    });

    describe('maxQtyReached', () => {
      test('set to true when qty == maxQty', () => {
        const localThis = { localQty: 3, maxQty: 3 };
        expect(QtyButtonBase.computed.maxQtyReached.call(localThis)).toBe(true);
      });

      test('set to false when qty < maxQty', () => {
        const localThis = { localQty: 2, maxQty: 4 };
        expect(QtyButtonBase.computed.maxQtyReached.call(localThis)).toBe(false);
      });
    });
  });

  describe('methods', () => {
    let sendUpdateSpy = jest.spyOn(QtyButtonBase.methods, 'sendUpdate');

    afterEach(() => {
      sendUpdateSpy.mockClear();
      notifyWarnMock.mockClear();
    });

    describe('incrementQty', () => {
      test('call sendUpdate method once', () => {
        const wrapper = factory({ qty: 1 });
        wrapper.vm.incrementQty();

        expect(sendUpdateSpy).toHaveBeenCalledTimes(1);
        expect(sendUpdateSpy).toHaveBeenCalledWith(2);
      });

      test('emit maxQtyReached when qty == maxQty, do not call sendUpdate', () => {
        const wrapper = factory({ qty: 3, maxQty: 3 });
        wrapper.vm.incrementQty();

        let event = wrapper.emitted().maxQtyReached;

        expect(sendUpdateSpy).toHaveBeenCalledTimes(0);
        expect(event).toBeTruthy();
        expect(event.length).toBe(1);
      });

      test('call notifyWarn with message', () => {
        const wrapper = factory({ qty: 3, maxQty: 3 });
        wrapper.vm.incrementQty();
        expect(notifyWarnMock).toHaveBeenCalledTimes(1);
        expect(notifyWarnMock).toHaveBeenCalledWith(expect.any(Object), 'Please contact Color Crew for larger quantities.', undefined);
      });

      test('default maxQty', () => {
        const wrapper = factory({ qty: 9 });
        wrapper.vm.incrementQty();

        let event = wrapper.emitted().maxQtyReached;

        expect(sendUpdateSpy).toHaveBeenCalledTimes(0);
        expect(event).toBeTruthy();
        expect(event.length).toBe(1);
      });

    });

    describe('decrementQty', () => {
      test('call sendUpdate method once', () => {
        const wrapper = factory({ qty: 5, maxQty: 5 });
        wrapper.vm.decrementQty();

        expect(sendUpdateSpy).toHaveBeenCalledTimes(1);
        expect(sendUpdateSpy).toHaveBeenCalledWith(4);
      });

      test('emit minQtyReached when qty == minQty, do not call sendUpdate', () => {
        const wrapper = factory({ qty: 1 });
        wrapper.vm.decrementQty();

        let event = wrapper.emitted().minQtyReached;

        expect(sendUpdateSpy).toHaveBeenCalledTimes(0);
        expect(event).toBeTruthy();
        expect(event.length).toBe(1);
      });

      test('decrement with custom minQty', () => {
        const wrapper = factory({ qty: 4, minQty: 2 });
        wrapper.vm.decrementQty();

        expect(sendUpdateSpy).toHaveBeenCalledTimes(1);
        expect(sendUpdateSpy).toHaveBeenCalledWith(3);
      });

      test('do not decrement when custom minQty is met', () => {
        const wrapper = factory({ qty: 2, minQty: 2 });
        wrapper.vm.decrementQty();

        let event = wrapper.emitted().minQtyReached;

        expect(sendUpdateSpy).toHaveBeenCalledTimes(0);
        expect(event).toBeTruthy();
        expect(event.length).toBe(1);
      });

      test('default minQty', () => {
        const wrapper = factory({ qty: 1 });
        wrapper.vm.decrementQty();

        let event = wrapper.emitted().minQtyReached;

        expect(sendUpdateSpy).toHaveBeenCalledTimes(0);
        expect(event).toBeTruthy();
        expect(event.length).toBe(1);
      });
    });

    describe('sendUpdate', () => {
      test('emit qtyChange', () => {
        let qty = 3;
        const wrapper = factory({ qty: 1 });
        wrapper.vm.sendUpdate(qty);
        let event = wrapper.emitted().qtyChange;

        setTimeout(() => {
          expect(event).toBeTruthy();
          expect(event.length).toBe(1);
          expect(event[0]).toEqual([qty]);
        }, 501);
      });

      test('do not emit qtyChange when qty not passed in', () => {
        const wrapper = factory({ qty: 2 });
        wrapper.vm.sendUpdate();
        let event = wrapper.emitted().qtyChange;

        setTimeout(() => {
          expect(event).toBe(undefined);
        }, 501);
      });
    });

  });

});